export default "__VITE_ASSET__BrO6dw3a__"